module.exports = __webpack_public_path__ + "static/assets/4c768843c9fa6593074231cd762b83f8.ttf";